export default "__VITE_ASSET__57bd9e7f__"